module.exports = __webpack_public_path__ + "static/media/img8.6097f657.svg";